import ContaTable from './ContaTable';

export default ContaTable;
